var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
import { LabelGroup } from '@/models/LabelGroup';
import { Subject } from '@/models/Subject';
import { Component, Vue, Prop } from 'vue-property-decorator';
let StatusSetSelect = class StatusSetSelect extends Vue {
    constructor() {
        // File structure for Typescript files in your Vue project
        // https://tutorials.atabix.com/frontend/typscript_file_structure/
        super(...arguments);
        // #endregion
        // #region @Refs
        // #endregion
        // #region Class properties
        this.isLoading = true;
        this.statusSets = [];
        // #endregion
        // #region Getters & Setters
        // #endregion
        // #region @Watchers
        // #endregion
    }
    // #endregion
    // #region Lifecycle Hooks / Init
    mounted() {
        this.initialize();
    }
    async initialize() {
        this.isLoading = true;
        await this.fetchStatusSets();
        this.isLoading = false;
    }
    // #endregion
    // #region Class methods
    // #endregion
    // #region Async methods
    async fetchStatusSets() {
        this.statusSets = await new LabelGroup()
            .limit(999)
            .all();
    }
    async onInput(value) {
        // if (isEqual(this.value, value)) { return; }
        // this.$emit('input', value);
    }
};
__decorate([
    Prop({ default: false }),
    __metadata("design:type", typeof (_a = typeof Subject !== "undefined" && Subject) === "function" ? _a : Object)
], StatusSetSelect.prototype, "usePlaceholder", void 0);
StatusSetSelect = __decorate([
    Component({
        components: {
        //
        },
    })
], StatusSetSelect);
export default StatusSetSelect;
